// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__15Itw","productName":"Table_productName__2Z6d6"};